"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecoratedWorkspaceCatalog = exports.DecoratedWorkspaceCatalogFactory = void 0;
var tslib_1 = require("tslib");
var identity_1 = tslib_1.__importDefault(require("lodash/identity"));
/**
 * @alpha
 */
var DecoratedWorkspaceCatalogFactory = /** @class */ (function () {
    function DecoratedWorkspaceCatalogFactory(decorated, wrapper) {
        if (wrapper === void 0) { wrapper = identity_1.default; }
        this.decorated = decorated;
        this.wrapper = wrapper;
        this.workspace = this.decorated.workspace;
        this.options = this.decorated.options;
    }
    DecoratedWorkspaceCatalogFactory.prototype.forDataset = function (dataset) {
        return this.createNew(this.decorated.forDataset(dataset));
    };
    DecoratedWorkspaceCatalogFactory.prototype.forTypes = function (types) {
        return this.createNew(this.decorated.forTypes(types));
    };
    DecoratedWorkspaceCatalogFactory.prototype.excludeTags = function (tags) {
        return this.createNew(this.decorated.excludeTags(tags));
    };
    DecoratedWorkspaceCatalogFactory.prototype.includeTags = function (tags) {
        return this.createNew(this.decorated.includeTags(tags));
    };
    DecoratedWorkspaceCatalogFactory.prototype.withOptions = function (options) {
        return this.createNew(this.decorated.withOptions(options));
    };
    DecoratedWorkspaceCatalogFactory.prototype.load = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var catalog;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.decorated.load()];
                    case 1:
                        catalog = _a.sent();
                        return [2 /*return*/, this.wrapper(catalog)];
                }
            });
        });
    };
    return DecoratedWorkspaceCatalogFactory;
}());
exports.DecoratedWorkspaceCatalogFactory = DecoratedWorkspaceCatalogFactory;
/**
 * @alpha
 */
var DecoratedWorkspaceCatalog = /** @class */ (function () {
    function DecoratedWorkspaceCatalog(decorated) {
        this.decorated = decorated;
    }
    DecoratedWorkspaceCatalog.prototype.availableItems = function () {
        return this.decorated.availableItems();
    };
    DecoratedWorkspaceCatalog.prototype.attributes = function () {
        return this.decorated.attributes();
    };
    DecoratedWorkspaceCatalog.prototype.dateDatasets = function () {
        return this.decorated.dateDatasets();
    };
    DecoratedWorkspaceCatalog.prototype.facts = function () {
        return this.decorated.facts();
    };
    DecoratedWorkspaceCatalog.prototype.groups = function () {
        return this.decorated.groups();
    };
    DecoratedWorkspaceCatalog.prototype.allItems = function () {
        return this.decorated.allItems();
    };
    DecoratedWorkspaceCatalog.prototype.measures = function () {
        return this.decorated.measures();
    };
    return DecoratedWorkspaceCatalog;
}());
exports.DecoratedWorkspaceCatalog = DecoratedWorkspaceCatalog;
//# sourceMappingURL=catalog.js.map